// Rutas de assets de marca. Fuente única — cambiar aquí se propaga a
// Navbar, Footer (vía <Logo>), formulario de contacto y schema.js.
export const BRAND = {
  markGold: '/assets/brand/mark-gold.png', // isotipo dorado (fondos oscuros)
  markNavy: '/assets/brand/mark-navy.png', // isotipo navy (fondos claros)
  logoGoldNavy: '/assets/brand/logo-gold-navybg.png',
  logoNavyTransparent: '/assets/brand/logo-navy-transparent.png',
};
